<template>
  <section class='page-onlineEducation'>
    <resolution :current="onlineEducation"/>
  </section>
</template>

<script>
import resolution from './index.vue'
import { CONSOLE_SITE_URL } from '@/utils/constants';
export default {
  metaInfo: {
  title: '在线教育解决方案_互动课堂_双师课堂解决方案-马兰头医学科技',
  meta: [
    {
      name: 'keywords',
      content: '在线教育解决方案,互动课堂解决方案,在线课堂解决方案,双师课堂解决方案'
    },
    {
      name: 'description',
      content: '马兰头医学科技提供在线教育行业一站式解决方案，集视频、语音、文档、课件共享、直播于一体，满足大班直播课，互动小班课，双师课堂，音乐课堂等场景'
    },
  ]
  },
  name: 'onlineEducation',
  components: {
    resolution
  },
  data () {
    return {
      onlineEducation: {
        whyChoose: true,
        strength: {
          isGrey: true,
          title: '我们的优势',
          subtitle: '沉浸式教学体验，还原真实课堂',
          content: [{
            title: '录制回放',
            intro: '平台提供两种录制功能，可生成直播录制视频及云端回放链接。沉淀优质教学内容',
            img: require('@/assets/resolution/onlineEducation/icon1.png')
          },{
            title: '实时互动',
            intro: '文字交流和提问、举手/点名发言，关注到每个学生的课堂动态，让教育更精细化',
            img: require('@/assets/resolution/onlineEducation/icon2.png')
          },{
            title: '多功能组件',
            intro: '通过直播、图文、音频、视频等内容形式，课件共享、实时白板等互动形式，让教学场景更丰富',
            img: require('@/assets/resolution/onlineEducation/icon3.png')
          },{
            title: '高品质音画',
            intro: '最高极限4K编解码采集，业界领先的60FPS，超高清音画体验，超低延迟',
            img: require('@/assets/resolution/onlineEducation/icon4.png')
          },]
        },
        banner: {
          title: '在线教育解决方案',
          desc: '学校、培训机构等可在网上构建多个在线教室，学生可通过PC、手机、平板等加入互动课堂，足不出户即可完成名师授课<br>全面提升学校的教学效率和学生的自主学习能力',
          image: require('@/assets/resolution/onlineEducation/banner_img.png'),
          buttonText: '立即体验',
          buttonCallback: () => {
            window.open(CONSOLE_SITE_URL);
          }
        },
        use: {
          title: '使用场景',
          subtitle: '集视频、语音、文档、课件共享、直播于一体，使用简单，音画清晰，实时互动。',
          content: [{
            title: '大班直播课',
            subtitle: '对于成百上千人的大课，会议报告等适宜单向广播的教学场景需求，学生可以以观看直播的形式进入大直播间进行大课学习和收听报告等活动，大直播支持万人级别的高并发',
            img: require('@/assets/resolution/onlineEducation/case1.png')
          }, {
            title: '互动小班课',
            subtitle: '在线签到、一键上下课、音视频互动、桌面共享、多功能白板、文字交流和提问、举手/点名发言、听课统计报表、桌面监控、课程录制等。满足小班化教育个性需求',
            img: require('@/assets/resolution/onlineEducation/case2.png')
          }, {
            title: '双师课堂',
            subtitle: '每一位学生，都能接受优质的教育<br>线上主讲老师+线下辅导老师双重保障，教师课件、上课音视频实时同步输送，学生听课高清流畅，老师与学生互动无延迟，面对面交流，异地课堂感受零距离上课体验',
            img: require('@/assets/resolution/onlineEducation/case3.png')
          }, {
            title: '音乐课堂',
            subtitle: '音乐场景专属降噪算法，48kHz全频带音质，教学白板和曲谱标注',
            img: require('@/assets/resolution/onlineEducation/case4.png')
          }]
        },
        demonstration: {
          isGrey: true,
          choose: [6,7]
        }
      }
    }
  },
}
</script>

<style lang='less'>
.page-onlineEducation {}
</style>
